<template>
  <v-row no-gutters class="fill-height">
    <v-col cols="12" class="pa-2 fill-height">
      <v-card class="mb-2">
        <v-row no-gutters justify="center" align="center">
          <v-col cols="3" class="mr-2">
            <VueCtkDateTimePicker
              id="startDate"
              format="YYYY-MM-DD HH:mm"
              output-format="YYYY-MM-DD HH:mm"
              formatted="YYYY-MM-DD HH:mm"
              label="Start Date"
              v-model="startDate"
            />
          </v-col>
          <v-col cols="3" class="mr-2">
            <VueCtkDateTimePicker
              id="endDate"
              format="YYYY-MM-DD HH:mm"
              output-format="YYYY-MM-DD HH:mm"
              formatted="YYYY-MM-DD HH:mm"
              label="End Date"
              v-model="endDate"
            />
          </v-col>
          <v-col cols="3" shrink>
            <v-select
              label="Select a message"
              dense
              outlined
              hide-details
              :items="messages"
              item-text="Header"
              item-value="ID"
              v-model="selectedMessage"
            ></v-select>
          </v-col>
          <v-col cols="auto" shrink class="ml-2">
            <v-btn color="primary" @click="fetchMessageData" small>Filter</v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="pt-2">
        <v-row no-gutters justify="space-around">
          <v-col cols="3" class="pr-1" style="cursor:pointer;">
            <v-card class="text-center" color="red" dark>
              <v-sheet class="display-1" color="rgba(0, 0, 0, .12)">{{messageTotals.TotalFailed}}</v-sheet>

              <div class="title">Failed to deliver</div>
            </v-card>
          </v-col>
          <v-col cols="3" class="pr-1" style="cursor:pointer;">
            <v-card class="text-center" color="success" dark>
              <v-sheet class="display-1" color="rgba(0, 0, 0, .12)">{{messageTotals.TotalSent}}</v-sheet>

              <div class="title">Sent</div>
            </v-card>
          </v-col>
          <v-col cols="3" class="pr-1" style="cursor:pointer;">
            <v-card class="text-center" color="primary" dark>
              <v-sheet class="display-1" color="rgba(0, 0, 0, .12)">{{messageTotals.TotalRead}}</v-sheet>

              <div class="title">Read</div>
            </v-card>
          </v-col>
          <v-col cols="3" class="pr-1" style="cursor:pointer;">
            <v-card class="text-center" color="primary" dark>
              <v-sheet class="display-1" color="rgba(0, 0, 0, .12)">{{messageTotals.TotalReplies}}</v-sheet>

              <div class="title">Replied</div>
            </v-card>
          </v-col>
        </v-row>

        <!-- <ChartBase :chartData="issueChartData" v-if="issueChartData.length > 0" /> -->
      </v-card>

      <v-col cols="12" style="height: calc(100% - 130px); position:relative; overflow:auto;">
        <v-overlay v-model="fetchingData" absolute>fetching data...</v-overlay>
        <Grid
          ref="MessageDetailGrid"
          :Headers="Headers"
          :rowData="rowData"
          :extraOptions="gridOptions"
          :GridStyle="`height: 100%`"
        />
      </v-col>
    </v-col>
  </v-row>
</template>
<script>
import Grid from "@/components/Reports/report-base.vue";

export default {
  components: {
    Grid
  },
  data() {
    return {
      fetchingData: false,
      selectedMessage: null,
      messageTotals: {},
      messages: [],
      rowData: [],
      Headers: [],
      startDate: null,
      gridOptions: {
        enableCharts: true,
        getRowStyle: function(params) {
          if (params.data == undefined) {
            return { background: "" };
          }

          // if (params.data.HasError == "True") {
          //   return { background: "#FF6262" };
          // }
        }
      },
      endDate: this.FormatDateTime(new Date().setHours(23, 59, 59, 999)),
      startDate: this.FormatDateTime(
        this.subtractMonth(new Date().setHours(0, 0, 0, 0), 1)
      )
    };
  },
  beforeMount() {
    this.Headers = [
      {
        headerName: "Staff Name",
        field: "StaffName",
        resizable: true,
        enableRowGroup: true,
        filter: true,
        sortable: true,
        valueParser: this.valueParser,
        cellRendererFramework: "label",
        cellRendererParams: {
          innerRenderer: "label",
          suppressDoubleClickExpand: true,
          suppressEnterExpand: true
        },
        rowGroup: true,
        hide: true,
        suppressSizeToFit: true
      },
      {
        headerName: "Question",
        field: "Question",
        resizable: true,
        filter: true,
        enableRowGroup: true,
        sortable: true,
        valueParser: this.valueParser,
        rowGroup: false
      },
      {
        headerName: "Answer",
        field: "Answer",
        resizable: true,
        filter: true,
        enableRowGroup: true,
        sortable: true,
        valueParser: this.valueParser,
        rowGroup: false
      },
      {
        headerName: "Header",
        field: "Header",
        resizable: true,
        enableRowGroup: true,
        filter: true,
        sortable: true,
        valueParser: this.valueParser,
        rowGroup: false,
        hide: true
      },
      {
        headerName: "Body",
        field: "Body",
        resizable: true,
        filter: true,
        enableRowGroup: true,
        sortable: true,
        valueParser: this.valueParser,
        rowGroup: false,
        hide: true
      },
      {
        headerName: "Read",
        field: "Read",
        enableRowGroup: true,
        resizable: true,
        filter: true,
        sortable: true,
        valueParser: this.valueParser
      },
      {
        headerName: "Read Time",
        field: "ReadDateTimeString",
        enableRowGroup: true,
        resizable: true,
        filter: true,
        sortable: true,
        valueParser: this.valueParser
      },
      {
        headerName: "Replied",
        field: "Replied",
        resizable: true,
        filter: true,
        enableRowGroup: true,
        sortable: true,
        valueParser: this.valueParser
      },
      {
        headerName: "Replied Time",
        field: "RepliedDateTimeString",
        resizable: true,
        filter: true,
        enableRowGroup: true,
        sortable: true,
        valueParser: this.valueParser
      },
      {
        headerName: "Error",
        field: "Error",
        resizable: true,
        filter: true,
        enableRowGroup: true,
        sortable: true,
        valueParser: this.valueParser
      },
      {
        headerName: "Link",
        field: "ItemID",
        txType: "Message",
        cellRendererFramework: "LinkRenderer",
        cellStyle: { background: "white !important;" }
      }
    ];
  },
  watch: {
    startDate(val) {
      this.fetchMessages();
    },
    endDate(val) {
      this.fetchMessages();
    }
  },
  computed: {
    GroupedTransactions() {
      let self = this;

      if (self.rowData.length == 0) {
        let obj = {
          Header: null,
          Body: null,
          Transactions: []
        };

        return obj;
      }

      let obj = {
        Header: self.rowData[0].Header,
        Body: self.rowData[0].Body,
        Transactions: []
      };

      obj.Transactions = self.rowData.map(item => {
        let obj = item;
        obj.ReplyData = JSON.parse(obj.ReplyData);
        return obj;
      });

      return obj;
    }
  },
  mounted() {
    let self = this;

    self.fetchMessages();
  },
  methods: {
    fetchMessages() {
      let self = this;

      self
        .get(
          `Tenant/Report/Messages/GetMessages?startDate=${self.startDate}&endDate=${self.endDate}`
        )
        .then(r => {
          self.messages = r.data;
        });
    },
    fetchMessageData() {
      let self = this;
      let url = `Tenant/Report/Messages/GetMessageData?messageID=${self.selectedMessage}`;

      self.fetchingData = true;

      self
        .get(url)
        .then(r => {
          self.rowData = r.data.Transactions;
          self.messageTotals = r.data.Totals;
          self.fetchingData = false;
        })
        .catch(err => {
          self.fetchingData = false;
        });
    }
  }
};
</script>